module.exports = __webpack_public_path__ + "img/slovakia.dd373be.webp";